import { gql } from 'graphql-request';

const storeLayoutQuery = gql`
  query ($subdomain: String!) {
    store(subdomain: $subdomain) {
      id
      titleAr
      titleEn
      isCommissionBased
      showPoweredBy
      photoUrl
      pageTitleEn
      pageTitleAr
      footerEn
      footerAr
      hideStoreName
      faviconUrl
      descriptionEn
      descriptionAr
      hasActiveVouchers
      defaultCountry {
        id
        currency
      }
      logoUrl
      preferredLanguage
      published
      defaultProductPrepTime
      pwaSettings {
        icon
        manifest
      }
      branchesCount
      storeUi {
        productLayout
        categoryLayout
        fontShape
        buttonRounded
        logoRounded
        theme {
          palette {
            primary
            headerBackgroundColor
          }
        }
      }
      enabledOrderModes {
        delivery
        pickup
        carPickup
        beach
      }
      scheduleInfo {
        interval
      }
      setting {
        scheduleOrdersEnabled
        deliveryVatInclusive
        useDeliveryzonesMs
        multicountryEnabled
        googleMapsApiKey
        serviceFeeEnabled
        businessLegalDatum {
          companyNameAr
          companyNameEn
          vatIdNumber
        }
      }
      activeStorefrontCashbackProgram {
        id
        restaurantId
        percentage
        appliesTo
      }
    }
  }
`;

export default storeLayoutQuery;
